// src/helper/toMonthBool.js
/*
 * Нормалізує значення до булевого для полів "month".
 * 1 або true (також '1', 'true') -> true
 * 0, false, null, undefined, '' (а також '0', 'false', 'null', 'undefined') -> false
 *
 * @param {*} value Вхідне значення.
 * @returns {boolean} Результат нормалізації.
 */
export default function toMonthBool(value) {
	if (value === true || value === 1 || value === '1' || value === 'true') return true;

	// null/undefined:
	if (value == null) return false;

	// Явні "фолс"-варіанти:
	if (
		value === false ||
			value === 0 ||
			value === '' ||
			value === '0' ||
			value === 'false' ||
			value === 'null' ||
			value === 'undefined'
	) return false;

	// Будь-що інше теж вважаємо false за твоїм правилом
	return false;
}
